export async function getMediaDevices(kind?: MediaDeviceKind): Promise<MediaDeviceInfo[] | []> {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        throw new Error('enumerateDevices() is not supported');
    }

    const devices = await navigator.mediaDevices.enumerateDevices();
    return kind ? devices.filter(device => device.kind === kind) : devices;
}
